"use strict";
/**
 * 设置 cookie
 *
 * ### Example
 * ```
 * setCookie('key', 'value', {
 *      domain: 'meituan.com',
 *      path:   '/',
 *      end: Infinity,
 *      secure: true
 * });
 * ```
 * reference: MDN -> https://developer.mozilla.org/zh-CN/docs/Web/API/Document/cookie
 */
Object.defineProperty(exports, "__esModule", { value: true });
function setCookie(key, value, config) {
    var domainStr = '';
    var pathStr = '';
    var endStr = '';
    var secureStr = '';
    if (config && config.domain) {
        domainStr = "; domain=" + config.domain;
    }
    if (config && config.path) {
        pathStr = "; path=" + config.path;
    }
    if (config && config.end) {
        switch (config.end.constructor) {
            case Number:
                endStr = (config.end === Infinity) ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : "; max-age=" + config.end;
                break;
            case String:
                endStr = "; expires=" + config.end;
                break;
            case Date:
                endStr = "; expires=" + config.end.toUTCString();
                break;
        }
    }
    if (config && config.isSecure) {
        secureStr = '; secure';
    }
    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + domainStr + pathStr + endStr + secureStr;
}
exports.setCookie = setCookie;
